export default "__VITE_ASSET__189873fd__"